import {
  Button,
  Checkbox,
  Divider,
  LoadingOverlay,
  Modal,
  Select,
  TextInput,
} from "@mantine/core"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import React, { useEffect, useState } from "react"
import { DatePickerInput } from "@mantine/dates"
import * as FileSaver from "file-saver"
import { IconFileExport } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"
import { CollectionQuery, Filter } from "../../../models/collection.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import {
  useLazyGetPropertiesOfLeaseQuery,
  useLazyGetUnitsOfLeaseQuery,
} from "../../lease/store/lease.query"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { debounce } from "lodash"
import { Property } from "../../../models/property.model"
import { Unit } from "../../../models/unit.model"
import { use } from "i18next"

const ExportSalesModalComponent = (props: any) => {
  const { t } = useTranslation()
  const [userInfo, currentUserId, ownerInfo, tenantInfo] = useCurrentUser()

  const { opened, open, close, filteringVariables, exportFunction, filename } =
    props
  const [dateRangeValue, setDateRangeValue] = useState<
    [Date | null, Date | null]
  >([null, null])



  const [filterValue, setFilterValue] = useState<string[]>([])
  const [dateFilter, setDateFilterModel] = useState<Filter[]>([])
  const [collectionQuery, setCollectionQuery] = useState<CollectionQuery>({
    skip: 0,
    orderBy: [{ field: "createdAt", direction: "asc" }],
    includes: ["property", 'property.owner', "unit"],
  })
  const [propertySearch, setPropertySearch] = useState<string | null>(null)
  const [selectedProperty, setSelectedProperty] = useState<string>("")
  const [selectedUnit, setSelectedUnit] = useState<string>("")
  const [minimumAmount, setMinimumAmount] = useState<number>(0)
  const [maximumAmount, setMaximumAmount] = useState<number>(0)
  const [unitSearch, setUnitSearch] = useState<string | null>(null)
  const [propertiesCollection, setPropertiesCollection] =
    useState<CollectionQuery>({
      top: 10,
      skip: 0,
    })
  const [unitCollection, setUnitCollection] = useState<CollectionQuery>({
    top: 10,
    skip: 0,
  })

  const [exportLoading, setExportLoading] = useState<boolean>(false)

  const [getProperties, properties] = useLazyGetPropertiesOfLeaseQuery()
  const [getUnits, units] = useLazyGetUnitsOfLeaseQuery()
  const filterQuery = (data: string[]) => {
    let filterQueryValue: any[] = []
    const filterMap: { [key: string]: any[] } = {}
    data.forEach((item) => {
      filterMap[JSON.parse(item)?.field] = data.filter(
        (query) => JSON.parse(query)?.field === JSON.parse(item).field,
      )
    })
    // constructs the filter query into array form the grouped object
    Object.keys(filterMap).forEach((key) => {
      filterQueryValue = [
        ...filterQueryValue,
        filterMap[key].map((item) => JSON.parse(item)),
      ]
    })
    return filterQueryValue
  }

  useEffect(() => {
    if (dateRangeValue?.length > 0) {
      let date = []
      if (dateRangeValue?.[0] && dateRangeValue?.[1]) {
        date.push({
          field: "createdAt",
          value: [
            dateRangeValue?.[0]?.toISOString(),
            dateRangeValue?.[1]?.toISOString(),
          ],
          operator: "between",
        })
      }

      setDateFilterModel(date)
    }
  }, [dateRangeValue])

  useEffect(() => {
    const filter = filterQuery(filterValue)
    // const transportFilter = filterQuery(transportFilterValue);
    if (dateFilter.length > 0) {
      setCollectionQuery({
        ...collectionQuery,
        filter: [...filter, dateFilter],
      })
    } else {
      setCollectionQuery({
        ...collectionQuery,
        filter: [...filter],
      })
    }
  }, [filterValue, dateFilter, setCollectionQuery])

  useEffect(() => {
    if (userInfo?.role?.key == "super_admin") {
      getProperties(propertiesCollection)
    } else if (userInfo?.role?.key == "tenant") {
      getProperties({
        ...propertiesCollection,
        filter: [
          [
            {
              field: "ownerId",
              value: tenantInfo?.ownerId,
              operator: "=",
            },
          ],
        ],
      })
    } else {
      getProperties({
        ...propertiesCollection,
        filter: [
          [
            {
              field: "ownerId",
              value: ownerInfo?.parentOwnerId,
              operator: "=",
            },
          ],
        ],
      })
    }
  }, [propertiesCollection])
  useEffect(() => {
    if (selectedProperty) {
      getUnits({
        ...unitCollection,
        filter: [
          [
            {
              field: "propertyId",
              operator: "=",
              value: selectedProperty,
            },
          ],
        ],
      })
    }
  }, [unitCollection, selectedProperty])

  useEffect(() => {
    if (propertySearch) {
      if (userInfo?.role?.key == "super_admin") {
        getProperties({
          ...propertiesCollection,
          filter: [
            [{ field: "name", operator: "like", value: propertySearch }],
          ],
        })
      } else if (userInfo?.role?.key == "tenant") {
        getProperties({
          ...propertiesCollection,
          filter: [
            [{ field: "name", operator: "like", value: propertySearch }],
            [
              {
                field: "ownerId",
                operator: "=",
                value: tenantInfo?.ownerId,
              },
            ],
          ],
        })
      } else {
        getProperties({
          ...propertiesCollection,
          filter: [
            [{ field: "name", operator: "like", value: propertySearch }],
            [
              {
                field: "ownerId",
                operator: "=",
                value: ownerInfo?.parentOwnerId,
              },
            ],
          ],
        })
      }
    }
  }, [propertySearch])
  useEffect(() => {
    if (selectedProperty && unitSearch) {
      getUnits({
        ...unitCollection,
        filter: [
          [{ field: "name", operator: "like", value: unitSearch }],
          [{ field: "propertyId", operator: "=", value: selectedProperty }],
        ],
      })
    }
  }, [unitSearch])

  function _parseProperties() {
    let data: { label: string; value: string }[] = []

    properties?.data?.data?.map((property: Property) => {
      data.push({
        label: property?.name as string,
        value: property?.id as string,
      })
    })
    return data
  }
  function _parseUnits() {
    let data: { label: string; value: string }[] = []

    units?.data?.data?.map((unit: Unit) => {
      data.push({ label: unit?.name as string, value: unit?.id as string })
    })

    return data
  }
  const onExport = () => {
    setExportLoading(true)
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8;"

    let filter: Filter[][] = []
    if (selectedProperty) {
      if (selectedUnit) {
        filter.push([{ field: "unitId", operator: "=", value: selectedUnit }])
        filter.push([
          { field: "propertyId", operator: "=", value: selectedProperty },
        ])
      } else {
        filter.push([
          { field: "propertyId", operator: "=", value: selectedProperty },
        ])
      }
    }

    if (minimumAmount && maximumAmount) {
      filter.push([
        { field: "amount", operator: ">", value: minimumAmount },
        { field: "amount", operator: "<=", value: maximumAmount },
      ])
    } else {
      if (minimumAmount) {
        filter.push([{ field: "amount", operator: ">", value: minimumAmount }])
      }

      if (maximumAmount) {
        filter.push([{ field: "amount", operator: "<=", value: maximumAmount }])
      }
    }

    if(userInfo?.role?.key === "owner") {
      filter.push([{ field: "property.ownerId", operator: "=", value: ownerInfo?.parentOwnerId as string }])
    }
    console.log("🚀 ~ onExport ~ filter:", filter)

    exportFunction({ ...collectionQuery, filter: filter })
      .then((result: any) => {
        if (result) {
          const data = new Blob([result], { type: fileType })
          FileSaver.saveAs(data, filename)
          setExportLoading(false)
        }
      })
      .catch((e: any) => {
        setExportLoading(false)
        notification(
          "error",
          e?.message
            ? (e?.message as string)
            : "Unable to export the data. Please try again",
        )
      })
  }
  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        className="my-modal-content"
        withCloseButton={true}
        title={t("export")}
        padding={20}
        size={"lg"}
      >
        <div className="w-full">
          <div className="flex mb-4">
            <DatePickerInput
              className="w-full text-sm"
              dropdownType="modal"
              type="range"
              //@ts-ignore
              placeholder="Pick date range"
              allowSingleDateInRange
              value={dateRangeValue}
              onChange={setDateRangeValue}
              maw={400}
            />
          </div>
          <div className="flex mb-4 gap-3">
            <Select
              classNames={{ label: "dark:text-white mb-5" }}
              className="w-full"
              onKeyDown={debounce(
                (event: any) => setPropertySearch(event?.target?.value),
                1000,
              )}
              searchable
              clearable
              // withAsterisk
              // error={
              //     errors.propertyId &&
              //     `${errors?.propertyId?.message}`
              // }
              label={t("property", { count: 1 })}
              placeholder={t("property", { count: 1 })}
              data={_parseProperties()}
              value={selectedProperty}
              onChange={(e) => setSelectedProperty(e as string)}
            />
            <Select
              classNames={{ label: "dark:text-white" }}
              className="w-full"
              // withAsterisk
              onKeyDown={debounce(
                (event: any) => setUnitSearch(event?.target?.value),
                1000,
              )}
              searchable
              clearable
              // error={
              //     errors.unitId && `${errors?.unitId?.message}`
              // }
              description={t("unitDesc")}
              label={t("unit", { count: 1 })}
              placeholder={t("unit", { count: 1 })}
              data={_parseUnits()}
              // {...field}
              value={selectedUnit}
              onChange={(e) => setSelectedUnit(e as string)}
            />
          </div>

          <div className="flex gap-3">
            <TextInput
              classNames={{ label: "dark:text-white" }}
              className="w-full"
              // error={errors.amount && `${errors?.amount?.message}`}
              type="number"
              // withAsterisk
              label={t("minimumAmount")}
              placeholder={t("minimumAmount")}
              value={minimumAmount}
              onChange={(e) => setMinimumAmount(+e.target.value)}
            />
            <TextInput
              classNames={{ label: "dark:text-white" }}
              className="w-full"
              // error={errors.amount && `${errors?.amount?.message}`}
              type="number"
              // withAsterisk
              label={t("maximumAmount")}
              placeholder={t("maximumAmount")}
              value={maximumAmount}
              onChange={(e) => setMaximumAmount(+e.target.value)}
            />
          </div>

          <div className="flex-col space-y-2">
            <LoadingOverlay visible={false} overlayBlur={2} />

            <Checkbox.Group
              size="xs"
              className="flex-col  w-full justify-start "
              withAsterisk
              defaultValue={filterValue}
              value={filterValue}
              onChange={(data: any) => {
                setFilterValue(data)
              }}
            >
              {filteringVariables?.map((item: any, idx: number) => (
                <div key={idx}>
                  <div className="flex space-x-3  items-center">
                    {item.map((filter: any, index: number) => (
                      <Checkbox
                        key={index}
                        value={JSON.stringify(filter)}
                        label={filter.name}
                      />
                    ))}
                  </div>
                  {filteringVariables?.length !== idx + 1 && (
                    <Divider
                      label={t("and")}
                      labelPosition="center"
                      my={"xs"}
                    />
                  )}
                </div>
              ))}
            </Checkbox.Group>
          </div>

          <div className="mt-4  w-full flex justify-end">
            <Button
              loading={exportLoading}
              onClick={() => onExport()}
              size="xs"
              leftIcon={<IconFileExport />}
              className="flex bg-primary text-white"
            >
              Export
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ExportSalesModalComponent
